export default "__VITE_ASSET__BeETc41l__"